import { render, staticRenderFns } from "./ztServerConfig.vue?vue&type=template&id=7a9f40f2&scoped=true&"
import script from "./ztServerConfig.vue?vue&type=script&lang=tsx&"
export * from "./ztServerConfig.vue?vue&type=script&lang=tsx&"
import style0 from "./ztServerConfig.vue?vue&type=style&index=0&id=7a9f40f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f40f2",
  null
  
)

export default component.exports